export const getSelectedBackup = state => state.backup.selected_backup
